/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import React from 'react';
import { FireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import { useRouterActions } from '@atlassian/react-resource-router';

/**
 * This component will cause an SPA transition (and overwrite of current history) to Your work or the Projects directory
 * depending on whether nav-v3, Your work's deep dive cards, and the JSW onboarding flows in Your work are enabled.
 */
const JiraHomeOnboardingRedirect = (): React.JSX.Element => {
	const { replace } = useRouterActions();

	replace('/jira/your-work');

	return (
		<FireOperationalAnalytics
			eventName="JiraHomeOnboardingRedirect loaded"
			componentName="JiraHomeOnboardingRedirect"
			attributes={{ isRedirectionEnabled: true }}
		/>
	);
};

export default JiraHomeOnboardingRedirect;
